/**
 * How far a permission reaches. Ordered from narrowest to widest: a member who
 * holds `sales.view` at `department` scope also sees what `own` would show them.
 *
 * - own         records the member created or is assigned to
 * - department  records belonging to any department the member is in
 * - company     records belonging to any company the member's departments sit under
 * - tenant      every record in the agency
 */
export const SCOPES = ['own', 'department', 'company', 'tenant'] as const;

export type Scope = (typeof SCOPES)[number];

const RANK: Record<Scope, number> = { own: 1, department: 2, company: 3, tenant: 4 };

export function isScope(value: unknown): value is Scope {
  return typeof value === 'string' && value in RANK;
}

export function scopeRank(scope: Scope): number {
  return RANK[scope];
}

/** True when `held` reaches at least as far as `required`. */
export function scopeCovers(held: Scope, required: Scope): boolean {
  return RANK[held] >= RANK[required];
}

export function widerScope(a: Scope, b: Scope): Scope {
  return RANK[a] >= RANK[b] ? a : b;
}
